const i = ["+", " ", "(", ")", "-", "_", "."], l = (e, r = 1) => {
  if (typeof e != "string")
    return "";
  let t = e;
  i.forEach((s) => {
    t = t.split(s).join("");
  });
  const n = 10 + (r === !1 ? 0 : String(r).length);
  return t.length < n ? "" : r === !1 ? t : t.startsWith(String(r)) ? `+${t}` : `+${r}${t}`;
}, a = (e, r) => {
  const t = l(e, r);
  return r === !1 ? t.length === 10 : t.length > 10;
};
export {
  l as normalizePhoneNumber,
  a as phoneValidator
};
//# sourceMappingURL=phone.js.map
